import { defineMessages } from 'react-intl';

const _default_1: {
	redirectToWorkflow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	applyToWorkflow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraWorkflowEditorUIActionTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	redirectToWorkflow: {
		id: 'jira-workflow-editor.redirect.to.workflow',
		defaultMessage: 'Review workflow in editor',
		description:
			'Button label displayed on the redirect to workflow button in the Jira workflow wizard action card within the AI conversation interface. Shown as the text on a button. When clicked, it redirects the user to the workflow in the Jira workflow wizard.',
	},
	applyToWorkflow: {
		id: 'jira-workflow-editor.apply.to.workflow.in.editor',
		defaultMessage: 'Apply to workflow',
		description:
			'Button label displayed on the primary action button in the Jira workflow wizard action card within the AI conversation interface. Shown as the text on a button. When clicked, it applies the AI-suggested workflow changes (such as transitions, statuses, or rules) to the selected Jira workflow. The purpose is to provide a clear call-to-action for users to confirm and execute applying the workflow modifications.',
	},
	cancelAction: {
		id: 'jira-workflow-editor.cancel.action.in.editor',
		defaultMessage: 'Cancel',
		description:
			'Button label displayed on the cancel button in the Jira workflow wizard action card within the AI conversation interface. Shown as the text on a button. When clicked, it cancels the workflow editing action and discards any changes. The purpose is to provide users with a way to exit the workflow editing process without applying changes.',
	},
	jiraWorkflowEditorUIActionTitle: {
		id: 'jira-workflow-editor.title.in.editor',
		defaultMessage: 'Workflow editor',
		description:
			'Title text displayed at the top of an action card in the AI conversation interface when the AI suggests modifying a Jira workflow. Shown as the card header title. The purpose is to immediately communicate to the user what action the card represents, which is editing or configuring a Jira workflow.',
	},
});
export default _default_1;
